export function isMobile() {
    return "ontouchstart" in window;
}
